import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.css';
import PageHeader from '../../utils/PageHeader/PageHeader';
import NavBar from '../../utils/NavBar/NavBar';
import { ShopContext } from '../../../contexts/ShopContext';
import CallIcon from '../../icons/svg/call.svg';
import SanoftLogo from '../../icons/Logo/sanoft_logo.png';
import WhatsAppIcon from '../../icons/WhatsApp.png';
import CallImg from '../../icons/call_img.png';
import InstagramIcon from '../../icons/Instagram.png';
import LocationIcon from '../../icons/svg/location.svg';
import { Grid } from '@mui/material';
import { ROUTES } from '../../../const';

function ContactUs() {
  const history = useHistory();
  const { shop } = useContext(ShopContext);

  const address = shop?.config?.address;
  const slogan = shop?.config?.slogan;
  const instagramId = shop?.config?.instagram_id;
  const shopName = shop?.shop_name ?? shop?.name ?? "";
  const mobile_no = shop?.config?.mobile_no ?? shop?.mobile_no

  return (
    <div className={styles.contactPage}>
      <PageHeader title="Contact Us" />

      <div className={styles.container}>
        {/* shop details */}
        <div className={styles.shopDetails}>
          {/* Shop Logo */}
          {(shop?.cover_image || shop?.shop_logo) && <img src={shop?.cover_image || shop?.shop_logo} alt="Shop Logo" className={styles.logo} />}

          {/* Shop Name */}
          {shopName && <h3 className={styles.shopName}>{shopName}</h3>}

          {/* Slogan */}
          {slogan && <p className={styles.slogan}>{slogan}</p>}

          {/* Address */}
          {address && (
            <p className={styles.address}>
              <img src={LocationIcon} alt="location icon" className={styles.icon} />
              {address}
            </p>
          )}

          {/* Phone numbers */}
          {mobile_no && (
            <p className={styles.phone}>
              <img src={CallIcon} alt="call icon" className={styles.icon} />
              {mobile_no}
            </p>
          )}
        </div>

        {/* Social / Contact Buttons */}
        <div className={styles.socialButtons}>
          <div className={styles.linkTitle}>
            <div className={styles.line}></div>
            <span className={styles.text}>Stay Connected</span>
            <div className={styles.line}></div>
          </div>

          {/* Instagram */}
          {instagramId && (
            <a
              href={`https://instagram.com/${instagramId}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialBtn}
            >
              <img src={InstagramIcon} alt="Instagram icon" />
              Instagram
            </a>
          )}

          {/* WhatsApp */}
          {shop?.mobile_no && (
            <a
              href={`https://wa.me/${shop.mobile_no}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialBtn}
            >
              <img src={WhatsAppIcon} alt="whatsapp icon" />
              WhatsApp
            </a>
          )}

          {/* Call */}
          {shop?.mobile_no && (
            <a href={`tel:${shop.mobile_no}`} className={styles.socialBtn}>
              <img src={CallImg} alt="call icon" />
              Call
            </a>
          )}
          <div className={styles.linkTitle}>
            <div className={styles.line}></div>
            <span className={styles.text}>Policies</span>
            <div className={styles.line}></div>
          </div>
          <Grid container spacing={2} className={styles.policyLinks}>
            <Grid item xs={12} sm={6} >
              <Grid className={styles.linkbtn}
                onClick={() => {
                  history.push(ROUTES.TERMS_AND_CONDITIONS.replace(":shopId", shop.shopId));
                }}
              ><span>Terms and Conditions</span></Grid>
            </Grid>
            <Grid item xs={12} sm={6} >
              <Grid className={styles.linkbtn}
                onClick={() => {
                  history.push(ROUTES.PIVACY_POLICY.replace(":shopId", shop.shopId));
                }}
              ><span>Privacy Policy</span></Grid>
            </Grid>
            <Grid item xs={12} sm={6} >
              <Grid className={styles.linkbtn}
                onClick={() => {
                  history.push(ROUTES.REFUND_POLICY.replace(":shopId", shop.shopId));
                }}
              ><span>Refund Policy</span></Grid>
            </Grid>
            <Grid item xs={12} sm={6} >
              <Grid className={styles.linkbtn}
                onClick={() => {
                  history.push(ROUTES.SHIPPING_POLICY.replace(":shopId", shop.shopId));
                }}
              ><span>Shipping Policy</span></Grid>
            </Grid>
          </Grid>
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <h3 className={styles.footerContent}>Powered by</h3>
          <img src={SanoftLogo} alt="Sanoft Technologies" className={styles.sanoftLogo} />
        </div>

        <NavBar />
      </div>
    </div>
  );
}

export default ContactUs;
